export default __webpack_public_path__ + "static/media/discord.939d61c9.png";